<template>
  <swiper
    :slidesPerView="2"
    :spaceBetween="10"
    :slidesPerGroup="1"
      :breakpoints="{
      '550': {
        spaceBetween: 20,
      },
      '700': {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    }"
    :modules="modules"
    class="classes-swiper"
  >
    <swiper-slide>
      <h1>GYM</h1>
      <div class="img">
        <img src="../assets/imgs/classes-3.jpg" alt="">
      </div>
    </swiper-slide>
    <swiper-slide>
      <h1>YOGA</h1>
      <div class="img">
        <img src="../assets/imgs/classes-2.jpg" alt="">
      </div>
    </swiper-slide>
    <swiper-slide>
      <h1>BOXING</h1>
      <div class="img">
        <img src="../assets/imgs/classes-1.jpg" alt="">
      </div>
    </swiper-slide>
    <swiper-slide>
    </swiper-slide>
  </swiper>
</template>
<script>
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue";

// Import Swiper styles
import "swiper/css";

import "swiper/css/pagination";
import "swiper/css/navigation";

// import required modules
import { Pagination, Navigation } from "swiper";

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    return {
      modules: [Pagination, Navigation],
    };
  },
};
</script>
